


























































































































































































































import Vue from 'vue';
import { debounce, deburr, orderBy, toLower } from 'lodash';

import requester from '@/requester';
import {
  rulesBoolean,
  rulesEmail,
  rulesIntegerPositive,
  rulesRequired,
} from '@/utils/input-rules';

import InputTelefone from '@/components/inputs/InputTelefone.vue';

import { LojaScopesEnum } from '../../../../back/src/lojas/lojas.constants';
import { CategoriaUsuarioEnum } from '../../../../back/src/usuarios/usuarios.constants';
import { VinculoLojaUsuarioEnum } from '../../../../back/src/lojas/lojas.constants';

import InputNumber from '@/components/inputs/InputNumber.vue';
import { CategoriaPedidoItemEnum } from '../../../../back/src/pedidos/pedidos.constants';

export default Vue.extend({
  name: 'UsuariosFormFuncionario',
  components: {
    InputTelefone,
    InputNumber,
  },
  props: {
    usuario: {
      type: Object || null,
      default: null,
    },
  },
  data: () => ({
    loading: {
      grupos: true,
      categorias: true,
      lojas: true,
      submitForm: false,
    },
    form: {
      nome: null,
      sobrenome: null,
      email: null,
      celular: null,
      grupoId: null,
      lojaId: null,
      ativo: null,
      autorizarNovosDispositivos: true,
    },
    rules: {
      required: rulesRequired,
      email: [...rulesRequired, ...rulesEmail],
      boolean: rulesBoolean,
      integerPositive: rulesIntegerPositive,
    },
    selectLojaAdm: null,
    selectLojaComercial: null,
    grupos: [],
    lojas: [],
    categorias: [],
    itemsCategorias: [],
  }),
  computed: {
    disabledLojaId() {
      return (
        this.usuario?.lojas?.filter((el) =>
          [
            VinculoLojaUsuarioEnum.RESPONSAVEL_ADMINISTRATIVO,
            VinculoLojaUsuarioEnum.RESPONSAVEL_COMERCIAL,
          ].includes(el?.JoinLojaUsuario?.vinculo),
        )?.length > 0
      );
    },
    usuarioLogadoId() {
      return this.$store.getters?.usuario?.id || 0;
    },
    itemsGrupos() {
      return orderBy(
        this.grupos.map((el) => ({ value: el.id, text: el.nome })),
        (el) => deburr(toLower(el.text)),
      );
    },
    itemsLojas() {
      return orderBy(
        this.lojas.map((el) => ({
          value: el.id,
          text: `${el?.endereco?.municipioNome}${
            el?.endereco?.bairro ? ` - ${el.endereco.bairro}` : ''
          }`,
        })),
        (el) => deburr(toLower(el.text)),
      );
    },
    headers() {
      return [
        {
          value: 'categoria',
          text: this.$t('comum.categoria'),
          sortable: false,
        },
        {
          value: 'margemMinima',
          text: this.$t('comum.margemMinima'),
          sortable: false,
        },
        {
          value: 'margem',
          text: this.$t('comum.margemPadrao'),
          sortable: false,
        },
        {
          value: 'ativar',
          text: '',
          sortable: false,
        },
      ];
    },
  },
  async mounted() {
    await Promise.all([
      this.listaGrupos(),
      this.listaLojas(),
      this.listaCategorias(),
    ]);
    this.preencheForm();
  },
  methods: {
    preencheForm() {
      if (!this.usuario) return;
      this.form.nome = this.usuario?.nome || null;
      this.form.sobrenome = this.usuario?.sobrenome || null;
      this.form.email = this.usuario?.email || null;
      this.form.celular = this.usuario?.celular || null;
      this.form.grupoId = this.usuario?.grupoId || null;
      this.form.lojaId =
        this.usuario?.lojas?.find(
          (el) =>
            el?.JoinLojaUsuario?.vinculo === VinculoLojaUsuarioEnum.COMPRADOR,
        )?.id || null;
      this.form.ativo = this.usuario?.ativo ?? null;
      this.form.autorizarNovosDispositivos =
        this.usuario?.autorizarNovosDispositivos ?? null;
      this.itemsCategorias.forEach((itemCategoria, key) => {
        const usuarioMargem = this.usuario?.margens?.find(
          (el) => el.categoria === itemCategoria.categoria,
        );
        const margem = Number(usuarioMargem?.margem) * 100;
        const margemMinima = Number(usuarioMargem?.margemMinima) * 100;
        if (Number.isFinite(margem)) {
          this.$set(this.itemsCategorias[key], 'margem', margem);
          this.$set(this.itemsCategorias[key], 'margemMinima', margemMinima);
          this.$set(this.itemsCategorias[key], 'temMargem', true);
        }
      });
    },
    async listaGrupos() {
      this.loading.grupos = true;
      try {
        this.grupos = await requester.grupos.lista();
      } catch (err) {
        this.$root.$errorHandler(err);
      } finally {
        this.loading.grupos = false;
      }
    },
    async listaCategorias() {
      this.loading.categorias = true;
      try {
        this.categorias = Object.values(CategoriaPedidoItemEnum); // temporario
        this.itemsCategorias = this.categorias.map((el) => ({
          categoria: el,
          margem: null,
          temMargem: false,
        }));
      } catch (err) {
        this.$root.$errorHandler(err);
      } finally {
        this.loading.categorias = false;
      }
    },
    async listaLojas() {
      this.loading.lojas = true;
      try {
        const queryObject = {
          scope: LojaScopesEnum.ComUsuarios,
        };
        this.lojas = await requester.lojas.lista(queryObject);
      } catch (err) {
        this.$root.$errorHandler(err);
      } finally {
        this.loading.lojas = false;
      }
    },
    submitFormDebounce: debounce(async function () {
      await this.submitForm();
    }, 200),
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading.submitForm = true;
      try {
        const formData = {
          categoria: CategoriaUsuarioEnum.FUNCIONARIO,
          grupoId: this.form.grupoId || null,
          lojaId: this.form.lojaId || null,
          ...(this.usuario ? { ativo: this.form.ativo } : {}),
          autorizarNovosDispositivos: this.form.autorizarNovosDispositivos,
          nome: this.form.nome?.trim() || '',
          sobrenome: this.form.sobrenome?.trim() || '',
          email: this.form.email?.trim() || '',
          celular: this.form.celular?.trim() || '',
          margens: this.itemsCategorias
            .filter((el) => el.temMargem)
            .map((el) => ({
              categoria: el.categoria,
              margem: Number(el.margem) / 100,
              margemMinima: Number(el.margemMinima) / 100,
            })),
        };
        let usuario;
        if (this.usuario) {
          usuario = await requester.usuarios.altera(this.usuario.id, formData);
          this.$root.$emit(
            'toastSuccess',
            this.$t('comum.usuarioAlteradoComSucesso'),
          );
        } else {
          usuario = await requester.usuarios.cria(formData);
          this.$root.$emit(
            'toastSuccess',
            this.$t('comum.usuarioCriadoComSucesso'),
          );
        }
        this.$router.push({
          name: 'UsuariosVer',
          params: { usuarioId: usuario.id },
        });
      } catch (err) {
        this.$root.$errorHandler(err);
      } finally {
        this.loading.submitForm = false;
      }
    },
  },
});
